import { Box, Grid } from '@mui/material'
import { isArray } from 'lodash';
import React, { useEffect } from 'react'
import { FieldValues, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useRecoilValue } from 'recoil';
import AppSelectList, {
    IDropDownOptions
} from '../../../../Component/Common/Components/FormValidationInputs/AppSelectList';
import { MDTypography } from '../../../../Component/Common/Components/MDTypography'
import { VerificationCompanyAtom } from '../../../../State/VerificationCompany.Atom';
import {
    VerificationAgencyClientApplication
} from "../../../../Component/Model/Dto/VerificationAgency/VerificationAgencyClientApplication";
import {
    VerificationAgencyClientApplicationService
} from "../../../../Component/Api/VerificationAgency/VerificationAgencyClientApplication/VerificationAgencyClientApplicationService";
import { LoadingButton } from "@mui/lab";
import { CommisionerValidationSchema } from './CommisionerValidationSchema';
import AppYesOrNoSelector from '../../../../Component/Common/Components/FormValidationInputs/AppYesOrNoSelector';
import { yupResolver } from '@hookform/resolvers/yup';
import { MDButton } from '../../../../Component/Common/Components/MDButton';
import AppTextInput from '../../../../Component/Common/Components/FormValidationInputs/AppTextInput';

interface ICommisioner {
    token: any;
    setHandleNextCount: (i: number) => void;
    handleNextCount: number;
    submitForm: () => void;
}
export const CommisionerDetailsExternalPage = (props: ICommisioner) => {

    const verificationCompany = useRecoilValue(VerificationCompanyAtom);
    const [loading, setLoading] = React.useState(false);
    const [commisionerDetails, setCommisionerDetails] = React.useState(-1);
    const s: string = "xx";
    const yesNoDropdown: IDropDownOptions[] = [{ id: 1, value: "No" }, { id: 2, value: "Yes" }];
    const { control, handleSubmit, formState: { isSubmitting }, reset, watch } = useForm({
        mode: 'all',
        resolver: yupResolver(CommisionerValidationSchema),
    });

    const handleDataSubmit = async (data: FieldValues) => {
        try {
            const requestData = {
                VaClientApplicationId: verificationCompany.applicationId,
                HasReportedToBeeCommisioner: !!data.HasReportedToBeeCommisioner,
                IsBusinessUnderInvestigation: !!data.IsBusinessUnderInvestigation,
                BusinessUnderInvestigationDetail: data.BusinessUnderInvestigationDetail,
                ReportedToBEECommisionerDetail: data.ReportedToBEECommisionerDetail,
                token: props.token
            } as VerificationAgencyClientApplication.VerificationAgencyBeeCommisionerTempAccessDtoIn;

            if (commisionerDetails < 0 || !commisionerDetails) {
                var response = await VerificationAgencyClientApplicationService.CreateBeeCommisionerExternalPage(requestData);
                setCommisionerDetails(response.data.beeCommisionerId);
            }
            else {
                await VerificationAgencyClientApplicationService.UpdateBeeCommisionerExternalPage(requestData);
            }

            toast.success("BEE Commisioner Details Saved");
            props.submitForm();
        } catch (error: any) {
            console.log(error);
            if (isArray(error)) {
                let Errors: string[] = error;
                Errors.forEach((error: string) => {
                    toast.error(error);
                });
            }
        }
    }

    const getCommisionerDetails = async () => {
        const id = verificationCompany.applicationId;

        if (id !== -1) {
            try {
                const response = await VerificationAgencyClientApplicationService.GetBEECommisionerExternalPage(props.token);
                setCommisionerDetails(response.data.beeCommisionerId);
                const formData = {
                    IsBusinessUnderInvestigation: response.data.isBusinessUnderInvestigation,
                    HasReportedToBeeCommisioner: response.data.hasReportedToBeeCommisioner,
                    BusinessUnderInvestigationDetail: response.data.businessUnderInvestigationDetail,
                    ReportedToBEECommisionerDetail: response.data.reportedToBEECommisionerDetail
                };
                reset(formData);
            } catch (error) {
                console.log(error);
            }
        }
    }

    useEffect(() => {
        setLoading(true);
        getCommisionerDetails();
        setLoading(false);
    }, []);

    const isBusinessUnderInvestigation = watch("IsBusinessUnderInvestigation");
    const hasReportedToBeeCommisioner = watch("HasReportedToBeeCommisioner");
    const showBusinessUnderInvestigationDetail = Boolean(isBusinessUnderInvestigation);
    const showReportedToBeeCommisionerDetail = Boolean(hasReportedToBeeCommisioner);

    return (
        <Box>
            <MDTypography color='#000000' variant='h5' fontWeight='bold' >
                BEE Commissioner & Other
            </MDTypography>
            <MDTypography sx={{ fontSize: "15px", paddingBottom: "15px", paddingTop: "8px", color: "#727272" }}>
                Disclose ongoing investigations involving your business or structure. This transparency is essential for compliance reporting.
            </MDTypography>
            <form id='ApplicationDetailsForm' onSubmit={handleSubmit(handleDataSubmit)}>
                <Grid container spacing={3}>
                    <Grid item xs={9}>
                        <Grid>
                            <AppYesOrNoSelector control={control} name="IsBusinessUnderInvestigation" label='Is your business or any part of their structure or dealings currently under investigation?' size="small" />
                        </Grid>
                        {showBusinessUnderInvestigationDetail &&
                            <Grid item mt={2}>
                                <AppTextInput control={control} name="BusinessUnderInvestigationDetail" label='Please provide some additional information' multiline rows={5} />
                            </Grid>
                        }
                        <Grid mt={2}>
                            <AppYesOrNoSelector control={control} name="HasReportedToBeeCommisioner" label='Has your business had any part of their structure or dealings reported to the BBBEE Commission, either voluntarily/ internally or by any other party?' size="small" />
                        </Grid>
                        {showReportedToBeeCommisionerDetail &&
                            <Grid item mt={2}>
                                <AppTextInput control={control} name="ReportedToBEECommisionerDetail" label='Please provide some additional information' multiline rows={5} />
                            </Grid>
                        }
                    </Grid>
                </Grid>
                <Box mt={3} width='100%' display='flex' justifyContent='space-between'>
                    <Box>
                        <MDButton variant='outlined' color='dark' onClick={() => { props.setHandleNextCount(props.handleNextCount - 1); }}>
                            back
                        </MDButton>
                    </Box>
                    <LoadingButton loading={isSubmitting} variant='contained' form='ApplicationDetailsForm' type="submit" color='primary'>
                        Submit Application
                    </LoadingButton>
                </Box>
            </form>
        </Box>
    )
}

